








































import Vue from 'vue';
import AppSystemResourceViewModel from '../../../../services/viewModel/resource/AppSystemResourceViewModel';
import ProcessPendingIntegrationCallsRequestViewModel from '../../../../services/viewModel/resource/ProcessPendingIntegrationCallsRequestViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: {
    'layout-hostadmin': Vue.$auth.isInRole('hostadmin'),
    _hostadmin: Vue.$auth.isInRole('hostadmin'),
    'layout-admin': Vue.$auth.isInRole('admin'),
  },
  data: () => ({
    requestError: undefined as any,
    isLoading: false,
    model: new ProcessPendingIntegrationCallsRequestViewModel(),
    appSystems: [] as AppSystemResourceViewModel[],
  }),
  computed: {
  },
  mounted() {
    this.populateData();
  },
  methods: {
    async populateData() {
      const response = await this.$service.api.core.appSystem.getAppSystems();
      this.appSystems = response.items;
    },
    async processPendingIntegrationCalls() {
      this.isLoading = true;
      try {
        await this.$service.api.core.processes.processPendingIntegrationCalls(this.model);
      } catch (error: any) {
        this.requestError = error;
        Vue.$log.error(error);
      }
      this.isLoading = false;
    },
  },
});
